import { render, staticRenderFns } from "./TheAlertDialog.vue?vue&type=template&id=133513ad&scoped=true&lang=pug&"
import script from "./TheAlertDialog.vue?vue&type=script&lang=js&"
export * from "./TheAlertDialog.vue?vue&type=script&lang=js&"
import style0 from "./TheAlertDialog.vue?vue&type=style&index=0&id=133513ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133513ad",
  null
  
)

export default component.exports